module.exports = __webpack_public_path__ + "media/application/images/prowhy-logo-m-2ae8735703d56cf8a75a2247fe1ebddd.png";